/**
 *  Provide static calls for all methods.
 *
 *  Instead this: const users = new User().with('country').get()
 *  We can do this: const users = User.with('conutry').get()
 *
 */

export default class StaticModel {
  static instance () {
    return new this()
  }

  static include (...args) {
    const self = this.instance()
    self.include(...args)

    return self
  }

  static append (...args) {
    const self = this.instance()
    self.append(...args)

    return self
  }

  static select (...fields) {
    const self = this.instance()
    self.select(...fields)

    return self
  }

  static where (field, operator, value) {
    const self = this.instance()
    self.where(field, operator, value)

    return self
  }

  static whereIn (field, array) {
    const self = this.instance()
    self.whereIn(field, array)

    return self
  }

  static orderBy (...args) {
    const self = this.instance()
    self.orderBy(...args)

    return self
  }

  static page (value) {
    const self = this.instance()
    self.page(value)

    return self
  }

  static limit (value) {
    const self = this.instance()
    self.limit(value)

    return self
  }

  static custom (...args) {
    const self = this.instance()
    self.custom(...args)

    return self
  }

  static params (payload) {
    const self = this.instance()
    self.params(payload)

    return self
  }

  static first () {
    const self = this.instance()

    return self.first()
  }

  static find (id) {
    const self = this.instance()

    return self.find(id)
  }

  static fetch (cb) {
    const self = this.instance()

    return self.fetch(cb)
  }

  static get () {
    const self = this.instance()

    return self.get()
  }

  static loadFilters (filters) {
    const self = this.instance()

    return self.loadFilters(filters)
  }
}
